import React from 'react';
import { stats, studyAreas, studyAreasLabel } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-198" data-mp="m8x6j2xydnnd">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-199" data-mp="7l2dflg19h9r">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-200" data-mp="7kj58wg6q78x">
          {stats.map(stat => <div key={stat.label} data-id="element-201" data-mp="cicdrw4yndcd">
              <dt className="sr-only" data-id="element-202" data-mp="3uq1p9d62zytf">{stat.label}</dt>
              <dd data-id="element-203" data-mp="3uogvvqvi6lx5">
                <span className="block text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl" data-id="element-204" data-mp="3us4qktcopedg">
                  {stat.value}
                </span>
                <span className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-205" data-mp="3ksvzc897edus">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 border-t border-blue-200/70 pt-8 text-center" data-id="element-206" data-mp="1j10r62m5orhb">
          <p className="text-xs font-extrabold uppercase tracking-widest text-blue-600" data-id="element-207" data-mp="1ny0yshynm2aj">
            {studyAreasLabel}
          </p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-3" data-id="element-208" data-mp="2scvky9qa2ids">
            {studyAreas.map(area => <li key={area} className="rounded-full bg-white px-4 py-1.5 text-sm font-extrabold tracking-tight text-blue-800 ring-1 ring-blue-200" data-id="element-209" data-mp="324i6p008rzus">
                {area}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}